import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import {
  ProdutoGrupoModificadorDTO,
  ProdutoGrupoModificadorConsultaDTO,
  ReordenarDTO,
} from '../../models/cardapio-minishop/cardapio-minishop.model';

@Injectable({
  providedIn: 'root',
})
export class ProdutoGrupoModificadorService {

  private readonly basePath = '/api/produto-grupo-modificador';

  constructor(private apiService: ApiService) {}

  listar(produtoId: number): Observable<ProdutoGrupoModificadorConsultaDTO[]> {
    return this.apiService.read<ProdutoGrupoModificadorConsultaDTO[]>(
      `${this.basePath}?produtoId=${produtoId}`
    );
  }

  associar(dto: ProdutoGrupoModificadorDTO): Observable<ProdutoGrupoModificadorConsultaDTO> {
    return this.apiService.create<ProdutoGrupoModificadorConsultaDTO>(this.basePath, dto);
  }

  desassociar(id: number): Observable<any> {
    return this.apiService.delete(`${this.basePath}/${id}`);
  }

  reordenar(dto: ReordenarDTO): Observable<any> {
    return this.apiService.patch(`${this.basePath}/reordenar`, dto);
  }
}
